import IMAGES from '@/public/assets/img';
import { WEB_URL } from '@/config/endpoints';

export default {
    ShimmerSec:true,
    WhatsAppText:{
        labelText:'Connect to Whats app',
        desktopNo:'+919953052228',
        desktopMessage:"Hi, Welcome to Credlix's official WhatsApp account",
        mobileNo:'+917838156656',
        mobileMessage:"I'm interested in exploring Credlix's innovative financing solutions",
        contactName:'Credlix Official'
    },
    MenuLinks:[
        {name:'Financing Solutions', href:null, 
            subMenu:[
                    { name:'Export factoring', href: WEB_URL+'/export-factoring', text: 'Get up to 90% of the invoice value upon shipment', src: IMAGES.SHARED.eFinance},
                    { name: 'PO Finance', href: WEB_URL+'/export-factoring/purchase-order-financing', text: 'Receive quick and hassle-free advances against confirmed purchase orders', src: IMAGES.SHARED.poFinane},
                    { name: 'Sales Bill Discounting', href: WEB_URL+'/export-factoring/invoice-discounting-platform', text: 'Discount invoices to improve cash flow and help fund future material movement', src: IMAGES.SHARED.sbDiscount},
                    { name: 'Early Payment', href: WEB_URL+'/enterprise/early-payment-discount', text: 'Streamline cash flow and generate higher returns on your funds.', src: IMAGES.SHARED.ePayment},
                    { name: 'Vendor Finance', href: WEB_URL+'/enterprise/vendor-financing-india', text: 'Empower your suppliers with discounted accounts receivable in just two clicks', src: IMAGES.SHARED.vFinance},
                    { name: 'Channel Finance', href: WEB_URL+'/enterprise/channel-financing-india', text: 'Enable financing for your distributors through NBFCs and financial institutions',src: IMAGES.SHARED.cFinance},
                    { name: 'Business Loan', href: WEB_URL+'/business-loan', text: 'Get unsecured loans without risking your collateral',src: IMAGES.SHARED.loanLogo},
                    { name: 'Import Factoring', href: WEB_URL+'/import-factoring', text: 'Avail financing against your import invoices',src: IMAGES.SHARED.importLogo},
                    { name: 'CredlixRemit', href: WEB_URL+'/credlixremit',text: 'CredlixRemit – Direct INR Export Settlement & eFIRA Support',src: IMAGES.SHARED.credlixRemit},
                    { name: 'Purchase Invoice Discounting', href: WEB_URL+'/purchase-invoice-discounting', text: 'Pay Suppliers Today. Keep Your Working Capital for Tomorrow.', src: IMAGES.SHARED.pidLogo},
            ]
        },
        {name:'Global Buyer', href:WEB_URL+'/global-buyer',subMenu:null },
        {name:'Tools', href:null, subMenu:[
                { name: 'HSN Finder', href: WEB_URL+'/hsn-code', text: 'Find HSN Code or ITC HS Code for your product', src: IMAGES.SHARED.HSNFinder },
                { name: 'HTS Code Lookup', href: WEB_URL+'/hts-code', text: 'Find HTS Code or HS Code for your product', src: IMAGES.SHARED.HTSFinder },
                { name: 'Mexico Import Duty & Tariffs', href: WEB_URL+'/mexico-import-duty', text: 'Import duty % and tariff data for your products', src: IMAGES.SHARED.MexicoImportDuty },
                { name: 'Interest Calculator', href: WEB_URL+'/interest-calculator', text: 'Calculate Best Pricing For Export Financing', src: IMAGES.SHARED.iCalc },
                { name: 'Shipment Calculator', href: WEB_URL+'/shipment-calculator', text: 'Estimate your shipping in seconds', src: IMAGES.SHARED.shipmentCalculator },
                { name: 'Business Loan Calculator', href: WEB_URL+'/business-loan/emi-calculator', text: 'Calculate Your Business Loan EMI in Seconds', src: IMAGES.SHARED.businessLoanCalcIcon },
                { name: 'GST Number Search', href: WEB_URL+'/gst-number-search', text: 'Search using GSTIN to view registration details.', src: IMAGES.SHARED.gstSearchIcon },
            ]
        },
        {name:'Resources', href:null, subMenu:[
            { name: 'Articles', href: WEB_URL+'/articles', text:'Thoughts, tips & tech talk', src: IMAGES.SHARED.blogIcon },
            { name: 'Case Study', href: WEB_URL+'/case-studies', text: 'From challenge to change', src: IMAGES.SHARED.caseStudyIcon },
            { name: 'News', href: WEB_URL+'/news', text: 'The latest, all in one place', src: IMAGES.SHARED.newsIcon },
            { name: 'Webinars', href: WEB_URL+'/webinars', text: 'Expert insights, live and direct', src: IMAGES.SHARED.webinarIcon },
            { name: 'Events', href: WEB_URL+'/events', text: 'From vision to venue', src: IMAGES.SHARED.eventIcon },
            { name: 'Videos', href: WEB_URL+'/videos', text: 'Streaming knowledge, creativity, and more', src: IMAGES.SHARED.videoIcon },
            { name: 'Glossary', href: WEB_URL+'/finance-glossary', text: 'Trade finance glossary terms', src: IMAGES.SHARED.glossaryIcon },
        ]},
        {name:'Finsights', href:WEB_URL+'/credlix-finsight', subMenu:null},
        {name:'Contact',href:WEB_URL+'/contact-us', subMenu:null},
        { name: 'Partnership', href: WEB_URL+'/partner-program', text: 'Boost your earnings with diverse financial solutions'},
    ],
    Login: {name:'Login', href:'https://app.credlix.com/#/auth/login', PageName: 'HomePage', eventsname: 'Login'} ,
    SignUp:{name:'Signup', href:'https://app.credlix.com/nuphi/#/signup/exporter/verify',  PageName: 'HomePage', eventsname: 'HomePage_Signup'},

    // Content For footer starts
    FooterIndiaForm:true,
    FooterMexicoForm:false,
    FooterUSForm:false,
    FooterLeftText:{
        // heading:'Optimize your cash flow with Credlix and convert your accounts receivable into cash',
        // para:'Register on our platform and share some details about your company with us to provide you with a simple, personalized service tailored to your needs so that you can unleash the potential of your exports.',
        list:[
            'An ISO certified company',
            'Instant approval, quick disbursal',
            'Minimal documentation, no hard collateral',
            '100% visibility, digital dashboards',
            'FCI Member',
        ]
    },
    Scanner:true,
    ScannerText:{
        text1:'Apply for Credit',
        text2:'Give us a few details and leverage our supply chain expertise to get a customised approach for your supply chain financing needs.',
        text1Mobile:'Apply for Credit via WhatsApp Now​',
        textTapMobile: 'TAP HERE',
        textScan: 'Scan Here'
    },
    fixedCTA:'Get Financed',
    AddressIndia:{
        exporters:[
            { name: 'Exporters', href: WEB_URL+'/export-factoring', target: "_self" },
            { name: 'Invoice Discounting', href: WEB_URL+'/export-factoring/invoice-discounting-platform', target: "_self"},
            { name: 'Purchase Order Finance', href: WEB_URL+'/export-factoring/purchase-order-financing', target: "_self" },
            { name: 'FREE Buyer Credibility Check', href: WEB_URL+'/export-factoring/buyer-credit-check', target: "_self" },
            { name: 'Freight Invoice Discounting', href: WEB_URL+'/freight-invoice-discounting-india', target: "_self" },
            { name: 'Machinery Loans for Exporters', href: WEB_URL+'/machinery-loans-for-exporters-india', target: "_self" },
            { name: 'Business Loans for Professionals', href: WEB_URL+'/business-loan-professionals', target: "_self" },
            { name: 'Export Factoring Interest Subvention', href: WEB_URL+'/export-factoring-interest-subvention', target: "_self" },
            { name: 'CredlixRemit', href: WEB_URL+'/credlixremit', target: "_self" },
            { name: 'Purchase Invoice Discounting', href: WEB_URL+'/purchase-invoice-discounting', target: "_self" },
        ],
        enterprises:[
            { name: 'Enterprises', href: WEB_URL+'/enterprise', target: "_self" },
            { name: 'Early Payments', href: WEB_URL+'/enterprise/early-payment-discount', target: "_self" },
            { name: 'Vendor Finance', href: WEB_URL+'/enterprise/vendor-financing-india', target: "_self" },
            { name: 'Channel Finance', href: WEB_URL+'/enterprise/channel-financing-india', target: "_self" },
            { name: 'HSN Finder', href: WEB_URL+'/hsn-code', target: "_self" },
            { name: 'HTS Code Lookup', href: WEB_URL+'/hts-code', target: "_self" },
            { name: 'HSN by Keywords', href: WEB_URL+'/hsn-code/search', target: "_self" },
            { name: 'Mexico Import Duty & Tariffs', href: WEB_URL+'/mexico-import-duty', target: "_self" },
            { name: 'GST Number Search', href: WEB_URL+'/gst-number-search', target: "_self"},

        ],
        domestic:[
            { name: 'Domestic SMEs', href: WEB_URL+'/invoice-discounting-for-smes', target: "_self"},
            { name: 'Interest Calculator', href: WEB_URL+'/interest-calculator',target: "_self"},
            { name: 'Compliance', href: WEB_URL+'/assets/pdfs/DLAI-Code-of-Conduct-for-Responsible-Digital-Lending.pdf', target: "_blank"},
            { name: 'Credlix Finsights', href: '/credlix-finsight', target: "_self" },
            { name: 'Dealer & Distributor Financing', href: WEB_URL+'/dealer-distributor-financing', target:"_self" },
            { name: 'Industrial & Machinery Loan', href: WEB_URL+'/machinery-capex-financing', target:"_self" },
            { name: 'Corporate LAP', href: WEB_URL+'/corporate-loan-against-property', target:"_self" }
        ],
        company:[
            { name: 'About Us', href: WEB_URL+'/about-us', target:"_self" },
            { name: 'Careers', href: WEB_URL+'/careers', target:"_self" },
            { name: 'Articles', href: WEB_URL+'/articles', target:"_self" },
            { name: 'Contact Us', href: WEB_URL+'/contact-us', target:"_self" },
            // { name: 'Resources', href: WEB_URL+'/blogs', target:"_self" },
            { name: 'Partnership', href: WEB_URL+'/partnership', target:"_self" },
            { name: 'Grievance Redressal', href: WEB_URL+'/grievance-redressal', target:"_self" },
            { name: 'Glossary', href: WEB_URL+'/finance-glossary', target:"_self" },

        ],
        otherWebsites:[
            {name:'Business Moglix',href:"https://business.moglix.com"},
            {name:'Fabrication',href:"https://business.moglix.com/our-solutions/custom-fabrication"},
            {name:'Enterprise',href:"https://business.moglix.com/our-solutions/optimize-mro-procurement"},
            {name:'Packaging',href:"https://packaging.moglix.com"},
            {name:'DigiMRO',href:"https://www.digimro.com"},
            {name:'Moglix',href:"https://www.moglix.com"},
            {name:'TenderShark',href:"https://www.tendershark.com"},
            {name:'Moglix UAE',href:"https://www.moglix.ae"},
        ]
    },
    BackLinks:{
        // businessLoans:[
        //     {name:'Business Loan for Women', href:WEB_URL+'/business-loans/business-loan-for-women'},
        //     {name:'Business Loan for Agriculture', href:WEB_URL+'/business-loans/business-loan-for-agriculture'},
        //     {name:'MSME Business Loans', href:WEB_URL+'/business-loans/business-loan-for-msme'},
        //     {name:'Startup Business Loans', href:WEB_URL+'/business-loans/business-loan-for-startups'},
        //   ],
        financing:[
            {name:'Invoice Financing for Businesses', href:WEB_URL+'/export-factoring/invoice-discounting-platform'},
            {name:'Domestic and Export Factoring', href:WEB_URL+'/export-factoring'},
            {name:'Supply Chain Finance', href:WEB_URL+'/enterprise/early-payment-discount'},
          ],
          trade:[
              {name:'HSN Finder',href:WEB_URL+'/hsn-code'},
              {name:'HTS Code Lookup', href:'/hts-code'},
              {name:'Mexico Import Duty & Tariffs', href:'/mexico-import-duty'},
              {name:'Interest Calculator', href:'/interest-calculator'},
              {name:'Shipment Calculator', href:'/shipment-calculator'},
          ],
      
          business:[
              {name:'Working Capital Management',href:WEB_URL+'/export-factoring/invoice-discounting-platform'},
              {name:'PO Financing Options', href:WEB_URL+'/export-factoring/purchase-order-financing'},
              {name:'GST Business Loans', href:WEB_URL+'/business-loan'},
          ],
      
          globalTrade:[
              {name:'Nearshoring Opportunities in Mexico',href:WEB_URL+'/export-factoring/invoice-discounting-platform'},
              {name:'Cross-Border Trade Solutions', href:WEB_URL+'/global-buyer'},
          ],    
      
          whyCredlix:[
              {name:'Tailored Capital Solutions',href:WEB_URL},
              {name:'Instant Approval', href:WEB_URL+'/export-factoring'},
          ],    
    },
    copyright:'Copyright © ',
    CopyrightIndia:true,
    ExitForm:true,
    BlueBgHeading:'Do more for your Supply Chain with',
    CredlixLogoFooter:true,
    SuppList:[
        {image:IMAGES.SHARED.ftIcon1,boldText:'An ISO,',text:'Certified Company'},
        {image:IMAGES.SHARED.ftIcon2,boldText:'Minimal Documentation,',text:'no Hard Collateral'},
        {image:IMAGES.SHARED.ftIcon3,boldText:'Instant Approval,',text:'quick disbursal'},
        {image:IMAGES.SHARED.ftIcon4,boldText:'100 % visibility,',text:'digital dashboards'},
    ],
    ThankyouResponse:{
        ThankYou_page_heading:'Thank you for contacting with us.',
        ThankYou_page_para:'We will get back to you shortly',
       
    },
    SeoContent:{
        title:'Thank You for contacting',
        url:WEB_URL+'/thankyou-response',
        name:'description',
        description:'Thank You for contacting.'
    },
    ResLinks:[
        {link:'/articles',name:'Articles',target:'_self', PageName: 'Articles', eventsname: 'Blogs_Tab'},
        {link:'/case-studies',name:'Case Study',target:'_self', PageName: 'Case_Study', eventsname: 'Case_Study_Tab'},
        {link:'/news',name:'News',target:'_self', PageName: 'News', eventsname: 'News_Tab'},
        // {link:'https://finsights.credlix.com/',name:'Newsletter',target:'_target'},
        {link:'/webinars',name:'Webinars',target:'_self', PageName: 'Webinars', eventsname: 'Webinars_Tab'},
        {link:'/events',name:'Events',target:'_self', PageName: 'Events', eventsname: 'C_Events_Tab'},
        {link:'/videos',name:'Videos',target:'_self',  PageName: 'Videos', eventsname: 'Videos_Tab'},
    ],
    MexicoFormFieldsLabels:{
        commonError:'This field is required',
        emailNotValid:'The email is not valid.',
        restrictEmail:"Please provide the official email associated with the company.",
        phoneInvalid:'Invalid phone number.',
        heading1:'Get immediate access',
        heading2:'WORKING CAPITAL',
        emailLabel:'Email*',
        emailPlaceholder:'Enter your Email address',
        phoneLabel:'Phone number*',
        phonePlaceholder:'Enter your phone number',
        companyLabel:'Company Name*',
        companyPlaceholder:'Enter your Company name',
        financeLabel:'Required financing*',
        mIFinanceLabel:'Required financing (optional)',
        financePlaceholder:'Enter your financial amount..',
        submit:'Get financing',
        successMsg:'Successful submission: Thank you for your interest.',
        countrycodeLabel: 'Country code',
        countrycodePlaceholder: 'Select',
        companytypeLabel: 'Company type*',
        companytypePlaceholder: 'Enter your type of company..',
        countrycodeDataMexicoConnect:[
            {id:1, code:'Mexico (+52)', Showname:'Mexico (+52)'},
            {id:2, code:'Canada (+1)', Showname:'Canada (+1)'},
            {id:3, code:'USA (+1)', Showname:'United States (+1)'},
        ],
        // mITradeHeading:'Simplify your imports from India — Connect now',
        mISubBtn:'Connect Now',
       
    },
    miSupplier:{
        otpVerified:'OTP verified!',
        connectHeading:'Connect with Mexican Buyers — Apply Now',
        fetchDetails:'Fetch Details',
        companyName:'Company Name',
        name:'Enter your Name',
        emailId:'Enter your Email ID',
        phone:'Enter your Phone No',
        verify:'Verify',
        verifying:'Verifying...',
        verified:'Verified',
        invalidPhone:'Invalid phone number',
        captchaIssue:'Captcha or network issue',
        fetching:'Fetching...',
        getOtp:"Didn't get OTP?",
        resend:'Resend in',
        enterOtp:'Enter OTP',
        correctOtp:'Please enter correct OTP',
        incorrectOtp:'Incorrect OTP',
        term1:'I agree to the',
        terms:'Terms',
        privacy:'Privacy Policy',
        checkFinance:'Check Financing Eligibility',
        successMsg:'Successfull Submission : Thank you for your interest.'

    },

    // Content For footer end-------------------------------
    pageNotFound:{
        title:'Page Not Found',
        description:'Sorry, the page you are looking for could not be found.',

    },
    pageGone: {
        title: 'Page No Longer Available',
        description: 'This page is no longer available as the requested content has been permanently removed.',
        metaTitle: '410 - Page No Longer Available | Credlix',
        metaDescription: 'This page is no longer available as the requested content has been permanently removed.',
        returnTextPrefix: 'Or you can return to our ',
        homePageText: 'home page',
        homePageUrl: '/',
        returnTextMiddle: ', or ',
        contactUsText: 'contact us',
        contactUsUrl: '/contact-us',
        returnTextSuffix: '.'
    }
   

    

}
